export default __webpack_public_path__ + "static/media/logo-square-light.3acee033.webp";